module.exports = __webpack_public_path__ + "img/antigua-and-barbuda.454dc7e8.svg";